module.exports = __webpack_public_path__ + "static/media/20-dessverre.56ac21e1.mp3";